"use client";

import { useEffect } from "react";
import { telemetry } from "@/lib/telemetry";

export function AppTelemetry() {
  useEffect(() => {
    const emitVisibility = () => {
      telemetry.emit("app.visibility", {
        visibility_state: document.visibilityState,
        stream_active: false,
      });
    };
    const emitNetwork = (isOnline: boolean) => {
      telemetry.emit("app.network", {
        is_online: isOnline,
        stream_active: false,
      });
    };
    const onOnline = () => emitNetwork(true);
    const onOffline = () => emitNetwork(false);

    document.addEventListener("visibilitychange", emitVisibility);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);

    return () => {
      document.removeEventListener("visibilitychange", emitVisibility);
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  return null;
}
